<template>
  <div class="ReportDetails">
    <div class="store-sec">
      <el-card>
        <div class="storeName">
          <div>
            Bhayander <span class="date"> (From 01/08/2021 to 31/08/2021)</span>
          </div>
        </div>
        <div class="sales-sec">
          <div class="sales-block">
            <div class="sales-head">Total</div>
            <div class="sales-amount">
              {{ reportSummary.total ? reportSummary.total : "0" }}
            </div>
          </div>
          <div class="sales-block">
            <div class="sales-head">Task Assigned</div>
            <div class="sales-amount">
              {{ reportSummary.assigned ? reportSummary.assigned : "0" }}
            </div>
          </div>
          <div class="sales-block">
            <div class="sales-head">Completed</div>
            <div class="sales-amount">
              {{ reportSummary.completed ? reportSummary.completed : "0" }}
            </div>
          </div>
          <!-- <div class="sales-block">
          <div class="sales-head">Overtdue</div>
          <div class="sales-amount">{{reportSummary.overdue}}</div>
        </div> -->
          <div class="sales-block">
            <div class="sales-head">Incomplete</div>
            <div class="sales-amount">
              {{ reportSummary.overdue ? reportSummary.overdue : "0" }}
            </div>
          </div>
          <div class="sales-block">
            <div class="sales-head">Completion Rate</div>
            <div class="sales-amount">
              {{
                reportSummary.completetion_rate
                  ? reportSummary.completetion_rate.toFixed(2) + " %"
                  : "0"
              }}
            </div>
          </div>
        </div>

        <div class="table-sec">
          <div class="flex justify-end items-center mb-4">
            <div class="csv-outer">
              <div class="csv-btn">CSV <i class="el-icon-download"></i></div>
            </div>
          </div>

          <div class="table-outer event-table">
            <table class="report-tbl-inner">
              <thead>
                <tr>
                  <th class="fix-div" style="width: 180px">TASK</th>
                  <th class="fix-div2">REPEAT</th>
                  <th v-for="(i, index) in dateList" :key="index">
                    {{ i.date }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="fix-div" style="width: 180px">
                    <div class="task-detail">
                      <span style="font-weight: 600; color: #000"
                        >Shelf Setup</span
                      >
                      <div>Steps-4</div>
                      <div>Store Inventory Executive</div>
                      <div>18:00 - 20:00</div>
                    </div>
                  </td>
                  <td class="fix-div2">Weekly</td>
                  <td v-for="(i, index) in dateList" :key="index">
                    <div></div>
                    <!-- <img
                      class="status-icon"
                      src="../../../../../assets/images/checked.png"
                      alt=""
                    /> -->
                  </td>
                  <!-- <td>
                    <img
                      class="status-icon-wrong"
                      src="../../../../../assets/images/cancel.png"
                      alt=""
                    />
                  </td>
                  <td>
                    <img
                      class="status-icon"
                      src="../../../../../assets/images/checked.png"
                      alt=""
                    />
                  </td> -->
                </tr>
                <tr>
                  <td class="fix-div" style="width: 180px">
                    <div class="task-detail">
                      <span style="font-weight: 600; color: #000"
                        >Shelf Setup</span
                      >
                      <div>Steps-4</div>
                      <div>Store Inventory Executive</div>
                      <div>18:00 - 20:00</div>
                    </div>
                  </td>
                  <td class="fix-div2">Weekly</td>
                  <td>
                    <img
                      class="status-icon"
                      src="../../../../../assets/images/checked.png"
                      alt=""
                    />
                  </td>
                  <td>
                    <img
                      class="status-icon-wrong"
                      src="../../../../../assets/images/cancel.png"
                      alt=""
                    />
                  </td>
                  <td>
                    <img
                      class="status-icon"
                      src="../../../../../assets/images/checked.png"
                      alt=""
                    />
                  </td>
                </tr>
                <tr>
                  <td class="fix-div" style="width: 180px">
                    <div class="task-detail">
                      <span style="font-weight: 600; color: #000"
                        >Shelf Setup</span
                      >
                      <div>Steps-4</div>
                      <div>Store Inventory Executive</div>
                      <div>18:00 - 20:00</div>
                    </div>
                  </td>
                  <td class="fix-div2">Weekly</td>
                  <td>
                    <img
                      class="status-icon"
                      src="../../../../../assets/images/checked.png"
                      alt=""
                    />
                  </td>
                  <td>
                    <img
                      class="status-icon-wrong"
                      src="../../../../../assets/images/cancel.png"
                      alt=""
                    />
                  </td>
                  <td>
                    <img
                      class="status-icon"
                      src="../../../../../assets/images/checked.png"
                      alt=""
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { serverAddr } from "../../../../../networkConfig";
import moment from "moment";

export default {
  name: "ReportDetails",
  data() {
    return {
      reqParams: {},
      reportSummary: {},
      dateList: [],
      dialog_visible: false,
    };
  },
  mounted() {
    this.reqParams = JSON.parse(localStorage.getItem("reportReqParam"));
    console.log("this.reqParams", this.reqParams);
    this.getListOfDays();
    this.getReportData();
  },
  methods: {
    getListOfDays() {
      var getDaysBetweenDates = function (startDate, endDate) {
        var now = startDate.clone(),
          dates = [];
        var id = 0;

        while (now.isSameOrBefore(endDate)) {
          id++;
          var obj = {
            id: id,
            date: now.format("MM/DD/YYYY"),
          };
          dates.push(obj);
          now.add(1, "days");
        }
        return dates;
      };

      var startDate = moment(this.reqParams.start_date);
      var endDate = moment(this.reqParams.end_date);

      this.dateList = getDaysBetweenDates(startDate, endDate);
      console.log(this.dateList);
    },
    getReportData() {
      this.loading = true;
      serverAddr
        .post(`/task_assignment/report/`, this.reqParams)
        .then((response) => {
          if (response.status == 200) {
            var res = JSON.parse(response.data);
            this.reportSummary = res.summary;
            console.log(this.reportSummary);
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("./ReportDetails.scss");
</style>
